<template>
    <div id="app">
     
        <app-header></app-header>
            <router-view :key="$route.fullPath"/>
        <app-footer></app-footer>

        <to-top></to-top>

    </div>
</template>

<script>
import { mapActions } from "vuex";

var loadingIcon = require("./assets/icons/tail-spin.svg");

import Header from "./components/templates/Header";
import Footer from "./components/templates/Footer";
import BackToTop from "./components/BackToTop";

let moment = require("moment");

export default {
  name: "App",
  components: {
    appHeader: Header,
    appFooter: Footer,
    toTop: BackToTop
  },
  data() {
    return {
      // loadingIcon
      
    };
  },
  metaInfo: {
    // if no subcomponents specify a metaInfo.title, this title will be used
    title: "Silver Star",
    // all titles will be injected into this template
    titleTemplate: "%s ",
    // link: [{ rel: "icon", href: favicon }]
    meta: [
      { charset: 'utf-8' },
      { name: 'Silver Star Auto', content: 'Looking for a vehicle? Check out our range of personal and commercial vehicles from Mercedes-Benz, Peugeot and Citroën at Silver Star Auto.' },
      { name: 'viewport', content: 'width=device-width, initial-scale=1' }
    ]
    
  },

  methods: {
   
  },
  created() {
    
  },
  mounted(){
    $(document).mouseup(function(e){
   
     var cartbox = $(".branddropdown");
 

    // If the target of the click isn't the container
  
    //   if(!cartbox.is(e.target) && cartbox.has(e.target).length === 0){
    //     cartbox.hide();
    // }
     if(!cartbox.is(e.target)){
        cartbox.hide();
  }
   let externalScript = document.createElement('script')
    // externalScript.setAttribute('src', 'https://www.googletagmanager.com/gtag/js?id=UA-177097640-1')
     externalScript.setAttribute('src', 'https://www.googletagmanager.com/gtm.js?id=GTM-P37XCZQ')
    document.head.appendChild(externalScript);
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());

    gtag('config', 'GTM-P37XCZQ');


    

  });



  }
};
</script>

<style lang="scss">
@import "../node_modules/bootstrap/scss/bootstrap";
@import "./assets/css/owl.carousel.min.css";
@import "./assets/css/owl.theme.default.min.css";
@import "./assets/fonts.css";
@import "./assets/themify-icons.css";
</style>
